import { Switch as MuiSwitch } from '@mui/material'
import styled from '@emotion/styled'

interface SwitchButtonProps {
    checked: boolean
    onChange: (checked: boolean) => void
    onlabel?: string
    offlabel?: string
    style?: string
    disabled?: boolean
}

const StyledSwitch = styled(MuiSwitch)<{ style?: string }>`
    &.MuiSwitch-root {
        width: 48px;
        height: 26px;
    }

    & .MuiSwitch-switchBase {
        padding: 2px;
    }

    & .MuiSwitch-thumb {
        width: 22px;
        height: 22px;
    }

    & .MuiSwitch-track {
        border-radius: 26px / 2;
    }
`

const SwitchButton = ({ checked, onChange, onlabel, offlabel, style, disabled }: SwitchButtonProps) => {
    return (
        <StyledSwitch
            checked={checked}
            onChange={(e) => onChange(e.target.checked)}
            disabled={disabled}
            style={style}
        />
    )
}

export default SwitchButton
